import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

import Home from "@/pages/Home";
import Village from "@/pages/Village";
import Cohort from "@/pages/Cohort";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import Talent from "@/pages/Talent";
import TalentProfile from "@/pages/TalentProfile";
import SchoolPartners from "@/pages/SchoolPartners";
import BrandPartners from "@/pages/BrandPartners";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Press from "@/pages/Press";
import Apply from "@/pages/Apply";
import ApplyStudent from "@/pages/ApplyStudent";
import ApplySchool from "@/pages/ApplySchool";
import ApplyBrand from "@/pages/ApplyBrand";
import ApplyInterest from "@/pages/ApplyInterest";
import Admin from "@/pages/Admin";
import Onboarding from "@/pages/Onboarding";
import Acceptance from "@/pages/Acceptance";
import Missions from "@/pages/Missions";
import TransmissionEducation from "@/pages/TransmissionEducation";
import TransmissionIndustry from "@/pages/TransmissionIndustry";
import { IncomingTransmission } from "@/components/transmission/IncomingTransmission";

const Layout = ({ children }) => (
  <SmoothScroll>
    <div className="grain-dark relative min-h-screen bg-onyx">
      <Navbar />
      <main className="relative z-[2]">{children}</main>
      <IncomingTransmission />
      <Footer />
    </div>
  </SmoothScroll>
);

function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-right" richColors />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/village" element={<Village />} />
          <Route path="/cohort" element={<Cohort />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/campaigns/:slug" element={<CampaignDetail />} />
          <Route path="/issues/:slug" element={<CampaignDetail />} />
          <Route path="/talent" element={<Talent />} />
          <Route path="/talent/:slug" element={<TalentProfile />} />
          <Route path="/schools" element={<SchoolPartners />} />
          <Route path="/brands" element={<BrandPartners />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/press" element={<Press />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/student" element={<ApplyStudent />} />
          <Route path="/apply/school" element={<ApplySchool />} />
          <Route path="/apply/brand" element={<ApplyBrand />} />
          <Route path="/apply/:type" element={<ApplyInterest />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/onboarding/:token" element={<Onboarding />} />
          <Route path="/acceptance/:token" element={<Acceptance />} />
          <Route path="/missions/:token" element={<Missions />} />
          <Route path="/transmission/education" element={<TransmissionEducation />} />
          <Route path="/transmission/industry" element={<TransmissionIndustry />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
